/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Native_LimitInputs */

const th_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอปจะแจ้งเตือนขณะเปิดใช้งานอยู่เท่านั้น จะไม่มีการแจ้งเตือนเมื่อปิดแอป หากต้องการรับแจ้งเตือนบนมือถือขณะปิดแอป ให้เพิ่ม Remy ไปยังหน้าจอโฮมแล้วเปิดการแจ้งเตือนที่นั่น`)
};

const en_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app notifies you while it is open. Nothing arrives when it is closed — for alerts on a phone with the app closed, add Remy to your Home Screen and turn on notifications there.`)
};

const ja_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アプリが開いている間のみ通知します。閉じている間は届きません。アプリを閉じた状態でスマートフォンに通知を受け取るには、Remy をホーム画面に追加してそちらで通知をオンにしてください。`)
};

const zh_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`应用打开时会通知你。关闭后不会收到任何内容——若想在应用关闭时也收到手机提醒，请把 Remy 添加到主屏幕，并在那里打开通知。`)
};

const es_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La aplicación te avisa mientras está abierta. No llega nada cuando está cerrada: para recibir avisos en el móvil con la aplicación cerrada, añade Remy a tu pantalla de inicio y activa allí las notificaciones.`)
};

const pt_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O aplicativo avisa enquanto está aberto. Nada chega quando ele está fechado — para receber avisos no celular com o aplicativo fechado, adicione o Remy à sua Tela de Início e ligue as notificações lá.`)
};

const id_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi akan memberi tahu Anda selama terbuka. Saat tertutup tidak ada yang sampai — untuk peringatan di ponsel saat aplikasi tertutup, tambahkan Remy ke Layar Utama lalu nyalakan notifikasi di sana.`)
};

const fr_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’application vous prévient tant qu’elle est ouverte. Rien n’arrive lorsqu’elle est fermée — pour des alertes sur un téléphone application fermée, ajoutez Remy à votre écran d’accueil et activez-y les notifications.`)
};

const tl_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mababalitaan ka ng app habang bukas ito. Walang darating kapag sarado — para sa mga abiso sa telepono kapag sarado ang app, idagdag ang Remy sa Home Screen at buksan ang mga notipikasyon doon.`)
};

const vi_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ứng dụng sẽ báo cho bạn khi nó đang mở. Khi đóng thì không nhận được gì — muốn nhận cảnh báo trên điện thoại lúc ứng dụng đóng, hãy thêm Remy vào màn hình chính rồi bật thông báo ở đó.`)
};

const ko_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱이 열려 있는 동안에는 알려드립니다. 닫혀 있으면 아무것도 오지 않습니다 — 앱이 닫혀 있을 때 휴대폰에서 알림을 받으려면 Remy를 홈 화면에 추가하고 거기서 알림을 켜세요.`)
};

const de_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die App benachrichtigt dich, solange sie offen ist. Bei geschlossener App kommt nichts an — für Hinweise auf dem Handy bei geschlossener App füge Remy zum Home-Bildschirm hinzu und aktiviere dort die Benachrichtigungen.`)
};

const ru_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приложение будет уведомлять вас, пока оно открыто. Когда закрыто, ничего не придёт — чтобы получать оповещения на телефон при закрытом приложении, добавьте Remy на экран «Домой» и включите уведомления там.`)
};

const tr_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulama açıkken sizi bilgilendirir. Kapalıyken hiçbir şey ulaşmaz — uygulama kapalıyken telefonunuzda uyarı almak için Remy'yi Ana Ekrana ekleyin ve bildirimleri oradan açın.`)
};

const it_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'app ti avvisa finché resta aperta. Da chiusa non arriva nulla: per ricevere avvisi sul telefono ad app chiusa, aggiungi Remy alla schermata Home e attiva lì le notifiche.`)
};

const pl_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikacja powiadomi cię, dopóki jest otwarta. Przy zamkniętej nic nie dotrze — aby dostawać alerty na telefon przy zamkniętej aplikacji, dodaj Remy do ekranu początkowego i włącz tam powiadomienia.`)
};

const uk_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Застосунок сповіщатиме вас, поки він відкритий. Коли закритий, нічого не надійде — щоб отримувати сповіщення на телефон при закритому застосунку, додайте Remy на екран «Домівка» і ввімкніть сповіщення там.`)
};

const hi_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऐप खुला रहने तक आपको सूचित करेगा। बंद होने पर कुछ नहीं पहुँचेगा — ऐप बंद होने पर फ़ोन पर सूचनाएँ पाने के लिए Remy को होम स्क्रीन में जोड़ें और वहाँ सूचनाएँ चालू करें।`)
};

const ar_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيُشعرك التطبيق ما دام مفتوحًا. ولن يصل شيء وهو مغلق — لتصلك التنبيهات على الهاتف والتطبيق مغلق، أضف Remy إلى الشاشة الرئيسية وفعّل الإشعارات هناك.`)
};

const ms_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplikasi akan memberitahu anda selagi ia terbuka. Apabila tertutup tiada apa akan sampai — untuk mendapat amaran pada telefon ketika aplikasi tertutup, tambah Remy ke Skrin Utama dan hidupkan pemberitahuan di sana.`)
};

const bn_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপ খোলা থাকলে আপনাকে জানাবে। বন্ধ থাকলে কিছুই পৌঁছাবে না — অ্যাপ বন্ধ থাকা অবস্থায় ফোনে সতর্কতা পেতে Remy-কে হোম স্ক্রিনে যোগ করে সেখানে বিজ্ঞপ্তি চালু করুন।`)
};

const zh_tw2_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`應用程式開啟時會通知你。關閉後不會收到任何內容——若想在應用程式關閉時於手機收到提醒，請將 Remy 加入主畫面，並在那裡開啟通知。`)
};

const zh_hk2_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`應用程式開啟時會通知你。關閉後不會收到任何內容——若想在應用程式關閉時於手機收到提醒，請將 Remy 加入主畫面，並在那裡開啟通知。`)
};

const ur_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایپ کھلی رہنے تک آپ کو اطلاع دے گی۔ بند ہونے پر کچھ نہیں پہنچے گا — ایپ بند ہوتے ہوئے فون پر اطلاع پانے کے لیے Remy کو ہوم اسکرین میں شامل کر کے وہاں اطلاعات چالو کریں۔`)
};

const fa_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تا وقتی برنامه باز است به شما خبر می‌دهد. با بسته بودن چیزی نمی‌رسد — برای دریافت هشدار روی گوشی هنگام بسته بودن برنامه، Remy را به صفحهٔ خانه بیفزایید و اعلان‌ها را آنجا روشن کنید.`)
};

const sw_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programu itakujulisha ikiwa imefunguliwa. Ikifungwa hakuna kitakachofika — ili kupata arifa kwenye simu programu ikiwa imefungwa, ongeza Remy kwenye Skrini ya Mwanzo kisha uwashe arifa hapo.`)
};

const nl_push_native_limit = /** @type {(inputs: Push_Native_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De app waarschuwt je zolang hij open is. Bij een gesloten app komt er niets aan — wil je meldingen op je telefoon met de app dicht, zet Remy dan op je beginscherm en zet daar de meldingen aan.`)
};

/**
* | output |
* | --- |
* | "The app notifies you while it is open. Nothing arrives when it is closed — for alerts on a phone with the app closed, add Remy to your Home Screen and turn o..." |
*
* @param {Push_Native_LimitInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_native_limit = /** @type {((inputs?: Push_Native_LimitInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Native_LimitInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_native_limit(inputs)
	if (locale === "ja") return ja_push_native_limit(inputs)
	if (locale === "zh") return zh_push_native_limit(inputs)
	if (locale === "es") return es_push_native_limit(inputs)
	if (locale === "pt") return pt_push_native_limit(inputs)
	if (locale === "id") return id_push_native_limit(inputs)
	if (locale === "fr") return fr_push_native_limit(inputs)
	if (locale === "tl") return tl_push_native_limit(inputs)
	if (locale === "vi") return vi_push_native_limit(inputs)
	if (locale === "ko") return ko_push_native_limit(inputs)
	if (locale === "de") return de_push_native_limit(inputs)
	if (locale === "ru") return ru_push_native_limit(inputs)
	if (locale === "tr") return tr_push_native_limit(inputs)
	if (locale === "it") return it_push_native_limit(inputs)
	if (locale === "pl") return pl_push_native_limit(inputs)
	if (locale === "uk") return uk_push_native_limit(inputs)
	if (locale === "hi") return hi_push_native_limit(inputs)
	if (locale === "ar") return ar_push_native_limit(inputs)
	if (locale === "ms") return ms_push_native_limit(inputs)
	if (locale === "bn") return bn_push_native_limit(inputs)
	if (locale === "zh-TW") return zh_tw2_push_native_limit(inputs)
	if (locale === "zh-HK") return zh_hk2_push_native_limit(inputs)
	if (locale === "ur") return ur_push_native_limit(inputs)
	if (locale === "fa") return fa_push_native_limit(inputs)
	if (locale === "sw") return sw_push_native_limit(inputs)
	if (locale === "nl") return nl_push_native_limit(inputs)
	return en_push_native_limit(inputs)
});